export const POSITIONS = [
  'President',
  'Vice President',
  'Secretary',
  'Assistant Secretary',
  'Treasurer',
  'Auditor',
  'P.R.O.',
  'Business Manager',
  'Adviser',
  'Member',
];
